var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "customerSelect", staticStyle: { width: "800px" } },
    [
      _c("div", { staticClass: "upload" }, [
        _c("div", { staticClass: "input_box" }, [
          _c("div", { staticClass: "input" }, [
            _c("label", [_vm._v("客户编码 : ")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.customerCode,
                  expression: "customerCode",
                },
              ],
              attrs: { id: "customer_code" },
              domProps: { value: _vm.customerCode },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.customerCode = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("label", [_vm._v("客户名称 : ")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.customerName,
                  expression: "customerName",
                },
              ],
              attrs: { id: "customer_name" },
              domProps: { value: _vm.customerName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.customerName = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input" }, [
            _c("label", [_vm._v("集团编码 : ")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.groupCode,
                  expression: "groupCode",
                },
              ],
              attrs: { id: "group_code" },
              domProps: { value: _vm.groupCode },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.groupCode = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("label", [_vm._v("集团名称 : ")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.groupName,
                  expression: "groupName",
                },
              ],
              attrs: { id: "group_name" },
              domProps: { value: _vm.groupName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.groupName = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button_box" },
        [
          _c(
            "Button",
            { staticClass: "sav-btn", on: { click: _vm.syncItem } },
            [_vm._v("同步")]
          ),
          _vm._v(" "),
          _c(
            "Button",
            {
              staticClass: "sav-btn",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.getTableData.apply(null, arguments)
                },
              },
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c("Button", { staticClass: "sav-btn", on: { click: _vm.refresh } }, [
            _vm._v("重置"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pageNation" },
        [
          _c("Page", {
            attrs: {
              total: _vm.page.total,
              "show-sizer": "",
              "page-size-opts": _vm.page.pageSizeOpts,
              current: _vm.page.current,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "on-change": _vm.pageChange,
              "on-page-size-change": _vm.pageSizeChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c("Table", {
            attrs: {
              columns: _vm.tableConfig.columns,
              data: _vm.tableConfig.data,
            },
            on: { "on-selection-change": _vm.onSelectChange },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }